import { isSupabaseConfigured } from "../supabase";
import { createLocalStorageCategoryStore } from "./localStorageStore";
import { createSupabaseCategoryStore } from "./supabaseStore";
import type { CategoryStore } from "./types";

const useLocal =
  import.meta.env.VITE_E2E_BYPASS_AUTH === "true" || !isSupabaseConfigured;

export const categoryStore: CategoryStore = useLocal
  ? createLocalStorageCategoryStore()
  : createSupabaseCategoryStore();

export type { Category, CategoryStore } from "./types";
